import { dataTwoHearts } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTwoHearts = /*#__PURE__*/createIcon(dataTwoHearts)
export default IconTwoHearts
